// import { isEmpty } from 'core/packages/utils';

import { convertToMinutes, ExperienceInclusions, getEnvPoliciesOther } from '@utriper/core';

// import { parseLocationToModel } from './location';
// import { parseModusToModel } from './modus';

export const parseExperienceToModel = (experience) => {
    return {
        ...experience,
        id: experience?.id,
        experiencerId: experience?.experiencerId,
        name: experience?.name,
        status: experience?.status,
        experienceDetailId: experience?.expDetail[0].id,
        expDetailId: experience.expDetail ? experience?.expDetail[0]?.id : null,
        payNowType: experience.payNowType || 0,
        payNow: experience.payNow,
        originalPayNow: experience.payNow,
        expDetail: experience?.expDetail?.map((detail) => ({ ...detail, unitPricing: [] })),
        unitPricing: [],

        // availability: experience?.availability,
    };
};

// no se si es necesario otro parse, se podria ampliar el de arriba me parece, tendria que ver mejor la API
export const parseExperienceElementListToModel = (experience) => {
    return {
        id: experience.experienceId,
        expDetailId: experience.expDetailId,
        experienceDetailName: experience.experienceDetailName,
        from: experience.start,
        to: experience.end,
        price: experience.price,
        currency: experience.currency,
        availability: experience.availability,
        name: experience.experienceName,
        duration: experience.duration,

        // este es un ejemplo de respuesta!
        // "id": 18,
        //         "experienceDetailId": 1,
        //         "createdOn": "2021-09-28T18:35:17.000Z",
        //         "updatedOn": null,
        //         "date": 3,
        //         "start": "09:00:00",
        //         "end": "12:00:00",
        //         "price": 200,
        //         "currency": "CNH",
        //         "capacity": 23,
        //         "experienceId": 28,
        //         "experienceName": "abcde",
        //         "expDetailId": 18,
        //         "experienceDetailName": "asdf",
        //         "duration": 12,
        //         "availability": 23
    };
};

export const parseExperienceToObject = (data) => ({
    ...data,
    payNowType: data.payNowType || 0,
});

export const parseQrDataToModel = (qrData) => {
    return {
        // establishmentData: parseEstablishmentToModel(qrData),
        experiences: qrData.experiences.map(parseExperienceToModel),
    };
};

export const parseExperienceScheduleToModel = (experienceSchedule) => ({
    extendedProps: { ...experienceSchedule },
    id: experienceSchedule.id,
    start: new Date(experienceSchedule.startUTC).toISOString(),
    end: new Date(experienceSchedule.endUTC).toISOString(),
});

export const parseExperience = (experience) => ({
    ...experience,
    meetingPointData: experience?.meetingPointPlaceId
        ? {
              locationId: experience?.meetingPointPlaceId,
              location: experience?.meetingPoint,
              city: experience?.meetingPoint,
              country: experience?.meetingPoint,
              longitude: experience?.meetingPointLongitude,
              latitude: experience?.meetingPointLatitude,
          }
        : null,
    locationData: experience?.location
        ? {
              locationId: experience?.locationId,
              location: experience.location,
              city: experience?.city,
              country: experience?.country,
              longitude: experience?.longitude,
              latitude: experience?.latitude,
          }
        : null,
    cancelPolicies: !experience.cancelPolicies?.nonRefundable ? experience.cancelPolicies.additionals : [],
    refundable: !experience.cancelPolicies?.nonRefundable || false,
});

const getExpInclusions = (includes = [], experienceInclusions = [], includesOptions = [], type = ExperienceInclusions.IDS.included) => {
    const expInclusionsResponse = { add: [], remove: [] };

    if ((!Array.isArray(includes) || includes?.length <= 0) && (!Array.isArray(experienceInclusions) || experienceInclusions?.length <= 0)) return expInclusionsResponse;

    // Experience Inclusions To Add
    for (const includesId of includes) {
        if (!includesId) continue;

        if (Number.isInteger(includesId)) {
            const exists = experienceInclusions?.find((expInclusion) => expInclusion?.includesId === includesId);

            if (!exists) {
                expInclusionsResponse.add.push({
                    includesId,
                    type,
                });
            }
            continue;
        }
        const customOption = includesOptions.find((opt) => opt?.id === includesId);

        if (customOption?.label && !Number.isInteger(customOption?.expInclusionId)) {
            expInclusionsResponse.add.push({
                isCustom: true,
                customLabel: customOption.label?.trim(),
                type,
            });
        }
    }

    // Experience Inclusions To Remove
    for (const { id, includesId } of experienceInclusions) {
        if (Number.isInteger(includesId)) {
            if (!includes.includes(includesId)) {
                expInclusionsResponse.remove.push(id);
            }
            continue;
        }
        const optionId = includesOptions.find((opt) => opt?.expInclusionId === id)?.id;

        if (!includes.includes(optionId)) {
            expInclusionsResponse.remove.push(id);
        }
    }

    return expInclusionsResponse;
};

const getExpModuses = (moduses = [], expModuses = []) => {
    let modusesResponse = { add: [], remove: [] };
    if (!Array.isArray(moduses) || moduses?.length <= 0) return modusesResponse;

    modusesResponse.add = moduses.filter((modus) => !expModuses?.includes(modus)) || [];
    modusesResponse.remove = expModuses?.filter((modus) => !moduses.includes(modus)) || [];

    return modusesResponse;
};

const getExpCancelPolicies = (cancelPolicies = [], expCancelPolicies = []) => {
    let cancelPoliciesResponse = { add: [], remove: [] };
    if (!Array.isArray(cancelPolicies) || cancelPolicies?.length <= 0) return cancelPoliciesResponse;

    const cancelPoliciesToAdd = cancelPolicies.filter((cancelPolicy) => !Number.isInteger(cancelPolicy?.cancelPolicyId));

    cancelPoliciesResponse.add =
        cancelPoliciesToAdd?.map((cancelPolicy) => ({
            percentage: cancelPolicy?.percentage,
            time: convertToMinutes({ days: cancelPolicy?.days, hours: cancelPolicy?.hours }),
        })) || [];
    const cancelPoliciesToRemove = expCancelPolicies.filter((cancelPolicy) => cancelPolicies.find((cp) => cp?.cancelPolicyId === cancelPolicy?.id) === undefined);
    cancelPoliciesResponse.remove = cancelPoliciesToRemove?.map((cancelPolicy) => cancelPolicy?.id) || [];

    return cancelPoliciesResponse;
};

export const getExperienceData = (values, isAdd = true) => {
    const formData = { ...values };
    delete formData?.images;

    // Exp Inclusions
    const { add: includesToAdd = [], remove: includesToRemove = [] } = getExpInclusions(formData?.includes, formData?.experienceInclusions?.includes, formData?.customIncludes);
    const { add: notIncludesToAdd = [], remove: notIncludesToRemove = [] } = getExpInclusions(formData?.notIncludes, formData?.experienceInclusions?.notIncludes, formData?.customNotIncludes, ExperienceInclusions.IDS.notincluded);
    const expInclusionsToAdd = [...includesToAdd, ...notIncludesToAdd];
    const expInclusionsToRemove = [...includesToRemove, ...notIncludesToRemove];
    const experienceInclusions = isAdd ? expInclusionsToAdd : { add: expInclusionsToAdd, remove: expInclusionsToRemove };

    const modusesIds = formData?.moduses?.map((modus) => modus?.id);
    const moduses = isAdd ? modusesIds : getExpModuses(modusesIds, formData?.experienceModuses);
    const cancelPolicies = isAdd ? getExpCancelPolicies(formData?.cancelPolicies, formData?.experienceCancelPolicies).add : getExpCancelPolicies(formData?.cancelPolicies, formData?.experienceCancelPolicies);

    const paymentMethods = formData?.paymentMethods?.map((paymentMethod) => paymentMethod?.id) || [];
    const envPolicies = formData?.envPolicies?.filter((envPolicy) => envPolicy !== 5) || [];

    const anticipation = convertToMinutes({ days: parseInt(formData?.anticipationDays) || 0, hours: parseInt(formData?.anticipationHours) || 0, minutes: parseInt(formData?.anticipationMinutes) || 0 }) || null; //minutes: parseInt(formData?.anticipationMinutes) || 0 }) || null;
    const refundable = formData?.refundable && formData?.cancelPolicies?.length > 0;
    const price = parseFloat(formData?.price);
    const duration = parseFloat(formData?.duration);

    const experienceData = {
        name: formData?.name,
        description1: formData?.description1,
        description2: formData?.description2,
        status: formData?.status,
        locationData: formData?.locationData,
        meetingPointData: formData?.meetingPointData,
        meetingInstructions: formData?.meetingInstructions,
        currency: formData?.currency,
        payNowType: formData?.payNowType,
        payNow: formData?.payNow,
        paxMessage: formData?.paxMessage,
        requireId: formData?.requireId,
        experienceInclusions,
        envPolicies,
        envPoliciesOther: getEnvPoliciesOther(formData?.envPolicies, formData?.customEnvPolicies),
        moduses,
        paymentMethods,
        cancelPolicies,
        anticipation,
        refundable,
        allowOpenDateBooking: formData?.allowOpenDateBooking,
        price: isNaN(price) ? null : price,
        priceGroupId: formData?.priceGroupId,
        duration: isNaN(duration) ? null : duration,
        timePeriod: formData?.timePeriod,
    };

    return experienceData;
};
